import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sd-layout-arrow",
  "use": "sd-layout-arrow-usage",
  "viewBox": "0 0 29 72",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 72\" id=\"sd-layout-arrow\"><path d=\"M3.615 38.602c-1.704-1.28-1.691-3.929.024-5.195C11.425 27.661 29 13.384 29 1.588v68.798c0-11.44-17.611-25.94-25.385-31.783z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol